import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { Box, Text } from '@components/Restyle';
import { WebIcon } from '@components/shared/Icon/WebIcon';
import theme from '@themes/theme';

interface ModalHeaderProps {
  title: string;
  titleVariant?: keyof typeof theme.textVariants;
  titleColor?: keyof typeof theme.colors;
  marginHorizontal?: keyof typeof theme.spacing;
  marginTop?: keyof typeof theme.spacing;
  onClose?: () => void;
  hideClose?: boolean;
  showBackButton?: boolean;
  rightAction?: React.ReactNode;
}

export const SimpleHeader: React.FC<ModalHeaderProps> = ({
  title,
  titleVariant,
  titleColor,
  marginHorizontal,
  marginTop = 'l',
  onClose,
  hideClose = false,
  showBackButton = false,
  rightAction,
}) => {
  const navigation = useNavigation();

  return (
    <Box
      accessibilityLabel={title}
      flexDirection='row'
      justifyContent='space-between'
      marginHorizontal={marginHorizontal ?? 'm'}
      mt={marginTop}>
      <Box flexDirection='row'>
        {showBackButton && (
          <WebIcon
            testId='back-button'
            accessibilityLabel='Go back'
            name='ChevronLeft'
            variant='l'
            color='textPrimary'
            onPress={() => {
              navigation.goBack();
            }}
          />
        )}
        <Text variant={titleVariant ?? 'labelLarge'} color={titleColor}>
          {title}
        </Text>
      </Box>

      <Box flexDirection='row' alignItems='center'>
        {rightAction}
        {!!onClose && !hideClose && !!rightAction && (
          <WebIcon
            accessibilityLabel={'Close ' + title}
            name='X'
            variant='l'
            color='black'
            onPress={onClose}
          />
        )}
      </Box>
      {!!onClose && !hideClose && !rightAction && (
        <WebIcon
          accessibilityLabel={'Close ' + title}
          name='X'
          variant='l'
          color='black'
          onPress={onClose}
        />
      )}
    </Box>
  );
};
